import React from "react";
import { Sparkles } from "lucide-react";

import { cn } from "../../utils/tailwindUtils";

/**
 * Horizontally scrolling prompt chips.
 *
 * `items` may be strings or `{ text, hrOnly }` objects; hrOnly entries are
 * filtered out for non-HR callers so the UI never suggests a question the
 * backend will answer with "restricted".
 */
const CopilotSuggestions = ({ items, onPick, disabled, isHr = false, compact = false }) => {
    const prompts = (items || [])
        .map((item) => (typeof item === "string" ? { text: item, hrOnly: false } : item))
        .filter((item) => isHr || !item.hrOnly);

    if (!prompts.length) return null;

    return (
        <div
            className={cn(
                "flex gap-2 overflow-x-auto pb-1",
                compact && "border-b border-border bg-muted/30 px-3 py-2"
            )}
        >
            {prompts.map((prompt) => (
                <button
                    key={prompt.text}
                    type="button"
                    disabled={disabled}
                    onClick={() => onPick(prompt.text)}
                    className={cn(
                        "inline-flex shrink-0 items-center gap-1.5 rounded-full border border-border bg-card",
                        "text-muted-foreground transition-colors",
                        "hover:border-sidebar-primary hover:text-sidebar-primary",
                        "disabled:cursor-not-allowed disabled:opacity-50",
                        compact ? "px-2.5 py-1 text-[11px]" : "px-3 py-1.5 text-xs"
                    )}
                >
                    <Sparkles className="h-3 w-3 text-sidebar-primary" />
                    {prompt.text}
                </button>
            ))}
        </div>
    );
};

export default CopilotSuggestions;
